import { IResource, ResourceType } from "@gettactic/api";

export const ResourceTypes: Record<ResourceType, ResourceType> = {
  area: "area",
  bike: "bike",
  booth: "booth",
  desk: "desk",
  locker: "locker",
  meeting_room: "meeting_room",
  other: "other",
  parking_lot: "parking_lot",
  parking_space: "parking_space",
  vehicle: "vehicle",
  workspace: "workspace"
} as const;

export const isRoom = (type: string): boolean =>
  type === ResourceTypes.meeting_room;

export const isWorkspace = (type: string): boolean =>
  type === ResourceTypes.desk || type === ResourceTypes.workspace;

export function isWorkingLocationOffice(locationId: string | null) {
  return locationId?.startsWith("offi_");
}

export function shouldEnablePrivacyForResourceType(
  resourceType: IResource["type"]
) {
  // Privacy is enabled for workspaces and desks, not rooms
  // client requested this due to that meetings are visible in outlook
  return isWorkspace(resourceType);
}
